import { useEffect } from 'react';
import WebStepperForm from 'src/components/Stepper/WebStepperForm';

/**
 * Step component for use with a form in a stepper.
 *
 * @param {React.ReactElement} component - The form component to be rendered within the step
 * @param {boolean} disableNext - Indicates if the 'next' button should be disabled
 * @param {boolean} isFirstStep - Indicates if step is the first step of all the form steps
 * @param {boolean} isLastStep - Indicates if step is the last step of all the form steps
 * @param {object} initialValues - Sets default values of the form
 * @param {React.ReactElement[]} modals - Modals to be rendered for this step outside of webstepper
 * @param {object} schema - Yup object that describes shape and values of form data
 * @param {function} onBack - Callback function for the 'back' button
 * @param {function} onNext - Callback function for the 'next' button
 * @param {function} onSubmit - Callback function for the 'submit' button
 * @param {boolean} isLoading - Indicates if the form is currently being submitted
 *
 * @returns {JSX.Element} - The `Step` component.
 */
export default function Step({
  component,
  disableNext,
  isFirstStep = false,
  isLastStep = false,
  initialValues = {},
  modals = [],
  schema = {},
  onBack = () => {},
  onNext = () => {},
  onSubmit = () => {},
  isLoading = false,
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {modals}
      <WebStepperForm
        disableNext={disableNext}
        enableReinitialize
        isFirst={isFirstStep}
        isLast={isLastStep}
        onBack={onBack}
        onNext={onNext}
        onSubmit={onSubmit}
        schema={schema}
        initialValues={initialValues}
        isLoading={isLoading}
      >
        {component}
      </WebStepperForm>
    </>
  );
}
